<mip-modal [size]="isMobile ? 'full' : 'md'">
  <!-- MODAL -->
  <mip-card>
    <!-- MODAL: HEADER -->
    <mip-toolbar class="__header" *ngIf="profile">
      <a class="__profile-slug-name" mat-button [routerLink]="'/@' + profile.username">
        <mip-profile-slug-name [user]="profile" badgeSize="5x"></mip-profile-slug-name>
      </a>
      <button mat-icon-button class="__close-btn" [routerLink]="'/@' + profile.username">
        <mip-icon icon="times"></mip-icon>
      </button>
    </mip-toolbar>

    <!-- MODAL: CONTENT -->
    <mip-card-content class="__info-content-container --no-padding">
      <mat-tab-group mat-stretch-tabs mat-align-tabs="start" dynamicHeight [selectedIndex]="activeTab" (selectedTabChange)="onSelectTab($event)">
        <!-- FOLLOWERS -->
        <mat-tab [label]="('profile.badges.followers' | translate) + ' (' + (followersCount | millify) + ')'" [title]="(followingCount | number) + ' followers'">
          <mip-profile-list-profiles
            class="__tab-content"
            *ngIf="followers || followers.length"
            [profiles]="followers"
            [loading]="loadingFollowers"
            (onReachingBottom)="getMoreFollowers()"
          ></mip-profile-list-profiles>
        </mat-tab>

        <!-- FOLLOWING -->
        <mat-tab [label]="('profile.badges.following' | translate) + ' (' + (followingCount | millify) + ')'" [title]="(followingCount | number) + ' following'">
          <mip-profile-list-profiles
            class="__tab-content"
            *ngIf="following || following.length"
            [profiles]="following"
            [loading]="loadingFollowing"
            (onReachingBottom)="getMoreFollowing()"
          ></mip-profile-list-profiles>
        </mat-tab>
      </mat-tab-group>
    </mip-card-content>
  </mip-card>
</mip-modal>
